module.exports = __webpack_public_path__ + "img/nameBac.3c7a9da3.png";